// extracted by mini-css-extract-plugin
export default {"similar-reports-section":"SimilarReportsSection_similar-reports-section__9H2L4","similar-reports-container":"SimilarReportsSection_similar-reports-container__ifq3m"};